import { BookMarked, LibraryBig, LockKeyhole, MoveUpRight, Newspaper, Speech, TrendingUp } from "lucide-react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Link } from "react-router-dom";

export default function Homepage() {

    const prioritydata = [
        {
            icon: <BookMarked size={64} className="text-xl text-white" />,
            color: "bg-blue-600",
            title: "Top \n magazines",
            description: "Stay updated with the latest trends and insights from industry-leading publications."
        },
        {
            icon: <Newspaper size={64} className="text-xl text-white" />,
            color: "bg-teal-500",
            title: "Daily Newspapers",
            description: "Stay informed about current events, national and international news, and stay ahead of the curve."
        },
        {
            icon: <LibraryBig size={64} className="text-xl text-white" />,
            color: "bg-yellow-600",
            title: "Reference Materials",
            description: " Access a vast collection of reliable resources, printed materials, and expert opinions."
        },
        {
            icon: <TrendingUp size={64} className="text-xl text-white" />,
            color: "bg-orange-600",
            title: "Career Guidance",
            description: "Get personalized advice and tools to navigate your professional journey and achieve your goals."
        },
        {
            icon: <Speech size={64} className="text-xl text-white" />,
            color: "bg-fuchsia-600",
            title: "Free \n Mentoring",
            description: "Connect with experienced professionals and gain valuable insights to shape your path."
        },
        {
            icon: <LockKeyhole size={64} className="text-xl text-white" />,
            color: "bg-green-600",
            title: "Highly Secured Environment",
            description: "Focus on your growth with peace of mind, in a safe and protected space."
        },
        
    ]
    
    return (
        <>
         <HelmetProvider>
                <Helmet>
                  <meta charset="UTF-8" />
                  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                  <title>Athena Study Hall - Home</title>
        
                  <meta name="keywords" content="Athena Study Hall Salem, Study Hall Salem, UPSC Study Hall, TNPSC Study Hall, Competitive exams Study Hall Tamil Nadu, 
                  IBPS Study Hall Salem, TET Study Hall Salem, TRB Study Hall Salem, DRB Study Hall Salem, Best UPSC Study Hall Salem, Best TNPSC Study Hall Salem, 
                  Online Study Hall for UPSC TNPSC, Offline Study Hall for competitive exams Salem, Study Hall for competitive exams Salem Tamil Nadu, UPSC TNPSC IBPS Study Hall 
                  Athena, Government exams Study Hall Salem, Bank exams Study Hall Salem, Athena Study Hall competitive exams, Salem Tamil Nadu Study Hall, UPSC classes Study Hall,
                  TNPSC coaching Study Hall, Athena Study Hall, UPSC coaching center, TNPSC coaching, Competitive exams coaching Study Hall, IBPS coaching institute, 
                  TET coaching classes, TRB coaching for teachers, DRB coaching center, UPSC online Study Hall TNPSC online classes, Competitive exams preparation Study Hall,
                  Best coaching for UPSC TNPSC, Bank exams coaching institute, Government exams coaching center, Online and offline Study Hall for competitive exams, Apply Now 
                  Athena Study Hall, Enroll Now UPSC TNPSC, Join Athena Study Hall, Apply Online Study Hall, Admission Open Athena Study Hall"/> 
        
                  <meta name="description" content="With a dedicated team of experienced educators, we provide a conducive study environment, comprehensive study materials, and personalized guidance to help students excel in their exams." />
        
                  <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1" />
                  <meta property="og:type" content="website" />
                  <meta property="og:image" content="/images/logo/favicon.png" />
        
                  <meta property="og:title" content="Athena Study Hall - An Ultimate Destination fo UPSC, TNPSC, IBPS, TET-TRB, SRD/DRB (Coop) Aspirants" />
        
                  <meta property="og:description" content="With a dedicated team of experienced educators, we provide a conducive study environment, comprehensive study materials, and personalized guidance to help students excel in their exams." />
        
                  <meta property="og:url" content="https://www.kavinsacademy.com/athena-study-hall" />
                  <meta property="og:site" content="Athena Study Hall" />
                  <meta property="og:site_name" content="Athena Study Hall" />
                  <link rel="canonical" href="https://www.kavinsacademy.comathena-study-hall" />
                  <meta name="facebook-domain-verification" content="0c59n4w2e5jlf2wlrjc7jjky6tzeuj" />
        
                  <meta name="twitter:card" content="summary_large_image" />
                  <meta name="twitter:site" content="@kavinsacademy" />
                  <meta name="twitter:title" content="Athena Study Hall | Distance Education in Tamil Nadu" />
                  <meta name="twitter:description" content="At Athena Study Hall, we're committed to helping you achieve your goals. Join us and take the first step towards success!" />
                  <meta name="twitter:image" content="/images/logo/favicon.png" />
        
                </Helmet>
              </HelmetProvider>
            <div className="relative z-40">
                <section className="bg-[url('/images/Studyhall/home.jpg')] h-[80dvh] relative z-40" style={{ clipPath: 'ellipse(100% 55% at 48% 44%)' }}>
                    <div className="absolute inset-0 bg-black opacity-45"></div>

                    <div className="relative flex items-center justify-center max-w-4xl mx-auto top-1/3">
                        <div className="space-y-6 text-center text-white">
                            <h1 className="text-6xl font-bold">Athena Study Hall</h1>
                            <p className="text-2xl font-medium">
                                A calm and dedicated study environment designed to help students learn with full concentration.
                            </p>
                        </div>
                    </div>
                </section>

                <div className="z-50 gap-5 space-y-3 sm:mx-1 sm:space-y-0 lg:-translate-x-1/2 lg:absolute sm:flex left-1/2 -bottom-14">
                    <div className="p-5 text-xl space-y-2  text-[#602233] shadow-xl text-center bg-regal-yellow rounded-xl w-52 mx-auto">
                        <h2 className="text-2xl font-semibold text-black">Study</h2>
                        <p className="font-medium">Unlock the power of knowledge.</p>
                    </div>
                    <div className="p-5 text-xl space-y-2 font-semibold text-[#602233] shadow-xl text-center bg-regal-yellow rounded-xl w-52 mx-auto">
                        <h2 className="text-2xl text-black">Focus</h2>
                        <p className="font-medium">Channel your energy, achieve greatness.</p>
                    </div>
                    <div className="p-5 text-xl space-y-2 font-semibold text-[#602233] shadow-xl text-center bg-regal-yellow rounded-xl w-52 mx-auto">
                        <h2 className="text-2xl text-black ">Grow</h2>
                        <p className="font-medium">Nurture your mind, transform your life.</p>
                    </div>
                </div>

            </div>

            <section className="py-10 mx-5 mt-4 lg:mt-32 lg:mx-5 xl:mx-5 2xl:mx-0">
                <div className="max-w-[85rem] mx-auto">
                    <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
                        <div className="relative lg:col-span-5 ">
                            <div className="space-y-3">
                                <h1 className="text-4xl font-semibold text-center lg:text-start lg:text-7xl">ABOUT US</h1>
                                <div className="bottom-0 space-y-4 lg:absolute">
                                    <div className="hidden md:block">
                                        <Link to={"/athena-study-hall/gallery"}>
                                            <button className="flex gap-2 px-4 py-2 font-semibold shadow-md border-1 duration-300 border-regal-blue rounded-2xl hover:bg-[#602233] hover:text-white hover:transition-transform ease-in-out">
                                                Visit our Gallery<MoveUpRight />
                                            </button>
                                        </Link>
                                    </div>
                                    <div className="overflow-hidden rounded-xl">
                                        <img src="/images/Studyhall/about1.jpeg" alt="About1" className="duration-300 ease-in-out rounded-xl hover:scale-105 hover:transition-transform" /> 
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="space-y-6 lg:col-span-7">
                            <div>
                                <p className="text-xl text-justify">Lorem ipsum dolor sit amet consectetur adipisicing elit. Quibusdam hic perferendis suscipit cum architecto ipsum rem corporis obcaecati neque eius? Minus omnis, odio deserunt reprehenderit voluptas amet maxime voluptatum libero.</p>
                            </div>
                            <div className="overflow-hidden rounded-xl">
                                <img src="/images/Studyhall/about2.jpeg" alt="About1" className="duration-300 ease-in-out rounded-xl hover:scale-105 hover:transition-transform"/>
                            </div>
                        </div>
                    </div>
                    <div className="flex items-center justify-center block mt-5 lg:hidden">
                    <Link to={"/athena-study-hall/gallery"}>
                        <button className="flex gap-2 px-4 py-2 font-semibold shadow-md border-1 duration-300 border-regal-blue rounded-2xl hover:bg-[#602233] hover:text-white hover:transition-transform ease-in-out">
                            Visit our Gallery<MoveUpRight />
                        </button>
                    </Link>
                    </div>
                </div>
            </section>

            <section className="mx-5 lg:py-10 lg:mx-0">
                <div className="max-w-[85rem] mx-auto">
                    <div className="text-center">
                        <h1 className="text-3xl font-semibold">Our Faclities</h1>
                        <p className="mt-4 text-xl">Experience well-crafted amenities designed for your comfort and productivity</p>
                    </div>
                    <div className="grid grid-cols-1 gap-8 mt-10 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4">
                         <div className="p-4 relative space-y-3 bg-white rounded-3xl shadow-[0px_1px_45px_0px_rgba(0,_0,_0,_0.1)] overflow-hidden">
                            <div className="overflow-hidden rounded-3xl"> 
                                <img src="/images/Studyhall/facilities/free_wifi.jpg" alt="Free wifi" loading="lazy" className="rounded-3xl w-[800px] h-[295px] hover:scale-105 hover:transition-transform hover:ease-in-out duration-300 object-cover object-center" />
                            </div>
                            <p className="text-xl font-semibold text-center">Free Wifi</p>
                            <div className="bg-[#602233] h-2 absolute inset-0 bottom-0 top-auto rounded-b-3xl"></div>
                        </div>
                         <div className="p-4 space-y-3 bg-white relative rounded-3xl shadow-[0px_1px_45px_0px_rgba(0,_0,_0,_0.1)] overflow-hidden">
                            <div className="overflow-hidden rounded-3xl">
                                <img src="/images/Studyhall/facilities/ro_water.webp" alt="Free wifi" loading="lazy" className="rounded-3xl w-[800px] h-[295px] hover:scale-105 hover:transition-transform hover:ease-in-out duration-300 object-cover object-center" />
                            </div>
                            <p className="text-xl font-semibold text-center">RO Water</p>
                            <div className="bg-[#602233] h-2 absolute inset-0 bottom-0 top-auto rounded-b-3xl"></div>
                        </div>
                        <div className="p-4 relative space-y-3 bg-white rounded-3xl shadow-[0px_1px_45px_0px_rgba(0,_0,_0,_0.1)] overflow-hidden">
                            <div className="overflow-hidden rounded-3xl">
                                <img src="/images/Studyhall/facilities/book_source.webp" alt="Free wifi" loading="lazy" className="rounded-3xl w-[800px] h-[295px] hover:scale-105 hover:transition-transform hover:ease-in-out duration-300 object-cover object-center" />
                            </div>
                            <p className="text-xl font-semibold text-center">Book Source</p>
                            <div className="bg-[#602233] h-2 absolute inset-0 bottom-0 top-auto rounded-b-3xl"></div>
                        </div>
                        <div className="p-4 relative space-y-3 bg-white rounded-3xl shadow-[0px_1px_45px_0px_rgba(0,_0,_0,_0.1)] overflow-hidden">
                            <div className="overflow-hidden rounded-3xl">
                                <img src="/images/Studyhall/facilities/rest_rooms.webp" alt="Free wifi" loading="lazy" className="rounded-3xl w-[800px] h-[295px] hover:scale-105 hover:transition-transform hover:ease-in-out duration-300 object-cover object-center" />
                            </div>
                            <p className="text-xl font-semibold text-center text2xl">Rest Rooms</p>
                            <div className="bg-[#602233] h-2 absolute inset-0 bottom-0 top-auto rounded-b-3xl"></div>
                        </div>
                        <div className="p-4 relative space-y-3 bg-white rounded-3xl shadow-[0px_1px_45px_0px_rgba(0,_0,_0,_0.1)] overflow-hidden">
                            <div className="overflow-hidden rounded-3xl">
                                <img src="/images/Studyhall/facilities/ro_water.webp" alt="Free wifi" loading="lazy" className="rounded-3xl w-[800px] h-[295px] hover:scale-105 hover:transition-transform hover:ease-in-out duration-300 object-cover object-center" />
                            </div>
                            <p className="text-xl font-semibold text-center">Private Cabin</p>
                            <div className="bg-[#602233] h-2 absolute inset-0 bottom-0 top-auto rounded-b-3xl"></div>
                        </div>
                        <div className="p-4 relative space-y-3 bg-white rounded-3xl shadow-[0px_1px_45px_0px_rgba(0,_0,_0,_0.1)] overflow-hidden">
                            <div className="overflow-hidden rounded-3xl">
                                <img src="/images/Studyhall/facilities/comfortable_seats.jpeg" alt="Free wifi" loading="lazy" className="rounded-3xl w-[800px] h-[295px] hover:scale-105 hover:transition-transform hover:ease-in-out duration-300 object-cover object-center" />
                            </div>
                            <p className="text-xl font-semibold text-center">Comfortable Seats</p>
                            <div className="bg-[#602233] h-2 absolute inset-0 bottom-0 top-auto rounded-b-3xl"></div>
                        </div>
                        <div className="p-4 relative space-y-3 bg-white rounded-3xl shadow-[0px_1px_45px_0px_rgba(0,_0,_0,_0.1)] overflow-hidden">
                            <div className="overflow-hidden rounded-3xl">
                                <img src="/images/Studyhall/facilities/sepe_diss_area.jpeg" alt="Free wifi" loading="lazy" className="rounded-3xl w-[800px] h-[295px] hover:scale-105 hover:transition-transform hover:ease-in-out duration-300 object-cover object-center" />
                            </div>
                            <p className="text-xl font-semibold text-center">Discussion and Dining area</p>
                            <div className="bg-[#602233] h-2 absolute inset-0 bottom-0 top-auto rounded-b-3xl"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-10 mx-5 lg:mx-5 2xl:mx-0">
                 <div className="max-w-[90rem] mx-auto">
                    <div className="text-center">
                        <h1 className="text-3xl font-semibold">Our Priorities</h1>
                        <p className="mt-4 text-xl">Focused learning, successful outcomes</p>
                    </div>
                    <div className="grid grid-cols-1 gap-10 mt-10 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6">
                       { prioritydata.map((item, index) => (
                        <div key={index} className="flex items-center justify-center hover:scale-105">
                            <div>
                                <div className={`flex items-center justify-center w-32 h-32 mx-auto ${item.color} rounded-full`}>
                                    {item.icon}
                                </div>
                                <div className="flex items-center justify-center">
                                    <div>
                                        <div>
                                            <img src="/images/Studyhall/down-arrow.png" alt="" className="w-20 mx-auto" />
                                        </div>
                                        <div className="relative flex items-center justify-center">
                                            <div className="">
                                                <p className={`px-5 py-2 text-xl font-semibold text-center text-white whitespace-pre-line ${item.color} border-2 rounded-2xl`}>{item.title}</p>
                                                <div className="flex flex-col justify-between p-5 text-center border-2 shadow-2xl rounded-2xl lg:h-full xl:h-fit 2xl:h-[230px]">
                                                    <p className="text-lg">{item.description}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>) )}
                    </div>
                 </div>
            </section>
        </>
    );
}
